/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-restricted-globals */
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { TextField, Box } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import CustomDialog from '../../../Components/Dialog/CustomDialog';

const RoleDialog = function RoleDialog({
  open,
  close,
  title,
  onSubmit,
  roleData,
}) {
  const intl = useIntl();

  const [licences, setLicences] = useState(null);
  const [checkValue, setCheckValue] = useState(false);
  const [prevLicences, setPrevLicences] = useState(null);

  useEffect(() => {
    if (open) {
      setLicences(roleData.licences);
      if (roleData.licences == null) {
        setCheckValue(true);
      }
    }
  }, [open]);

  const handleLicences = (e) => {
    setLicences(e.target.value);
  };

  const handleChange = (e) => {
    const isChecked = e.target.checked;
    setCheckValue(isChecked);

    if (isChecked) {
      setPrevLicences(licences);
      setLicences(null);
    } else {
      setLicences(prevLicences);
    }
  };
  const handleSubmit = () => {
    onSubmit({
      id: roleData.id,
      name: roleData.name,
      licences,
    });
  };

  const reset = () => {
    setLicences(null);
    setCheckValue(false);
    setPrevLicences(null);
  };

  return (
    <CustomDialog
      title={title}
      open={open}
      close={(_, reason) => {
        if (reason !== 'clickaway' && reason !== 'escapeKeyDown') {
          close();
          reset();
        }
      }}
      disableEscapeKeyDown
      notRequiredFields
      messageDialog
      maxWidth="xs"
      fullWidth
      onSubmit={() => {
        handleSubmit();
        reset();
      }}
      submitDisabled={
        !checkValue && (!licences || licences < roleData.activeUsers)
      }
      noBackdrop
      noForm
    >
      <Box
        sx={{
          display: "flex",
          width: "100%",
          flexDirection: "column"
        }}>
        <TextField
          id="licences-txtField"
          onChange={handleLicences}
          label={intl.messages.LICENCES}
          required
          disabled={checkValue}
          fullWidth
          value={checkValue ? null : licences}
          type="number"
        />
        <FormControlLabel
          control={<Checkbox checked={checkValue} onChange={handleChange} />}
          label={intl.messages.UNLIMITED}
        />
      </Box>
    </CustomDialog>
  );
};

RoleDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  roleData: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

export default RoleDialog;
